import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "sliders",
		clipPath: "url(#clip0_623_1689)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.66667 8.66667C3.03486 8.66667 3.33333 8.96515 3.33333 9.33334V14C3.33333 14.3682 3.03486 14.6667 2.66667 14.6667C2.29848 14.6667 2 14.3682 2 14V9.33334C2 8.96515 2.29848 8.66667 2.66667 8.66667Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.66667 1.33333C3.03486 1.33333 3.33333 1.63181 3.33333 2V6.66666C3.33333 7.03485 3.03486 7.33333 2.66667 7.33333C2.29848 7.33333 2 7.03485 2 6.66666V2C2 1.63181 2.29848 1.33333 2.66667 1.33333Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_3",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.99998 7.33333C8.36817 7.33333 8.66665 7.63181 8.66665 8V14C8.66665 14.3682 8.36817 14.6667 7.99998 14.6667C7.63179 14.6667 7.33331 14.3682 7.33331 14V8C7.33331 7.63181 7.63179 7.33333 7.99998 7.33333Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_4",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.99998 1.33333C8.36817 1.33333 8.66665 1.63181 8.66665 2V5.33333C8.66665 5.70152 8.36817 6 7.99998 6C7.63179 6 7.33331 5.70152 7.33331 5.33333V2C7.33331 1.63181 7.63179 1.33333 7.99998 1.33333Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_5",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.3334 10C13.7015 10 14 10.2985 14 10.6667V14C14 14.3682 13.7015 14.6667 13.3334 14.6667C12.9652 14.6667 12.6667 14.3682 12.6667 14V10.6667C12.6667 10.2985 12.9652 10 13.3334 10Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_6",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.3334 1.33333C13.7015 1.33333 14 1.63181 14 2V8C14 8.36819 13.7015 8.66666 13.3334 8.66666C12.9652 8.66666 12.6667 8.36819 12.6667 8V2C12.6667 1.63181 12.9652 1.33333 13.3334 1.33333Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_7",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0 9.33334C0 8.96515 0.298477 8.66667 0.666667 8.66667H4.66667C5.03486 8.66667 5.33333 8.96515 5.33333 9.33334C5.33333 9.70153 5.03486 10 4.66667 10H0.666667C0.298477 10 0 9.70153 0 9.33334Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_8",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.33331 5.33334C5.33331 4.96515 5.63179 4.66667 5.99998 4.66667H9.99998C10.3682 4.66667 10.6666 4.96515 10.6666 5.33334C10.6666 5.70153 10.3682 6.00001 9.99998 6.00001H5.99998C5.63179 6.00001 5.33331 5.70153 5.33331 5.33334Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_9",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.6667 10.6667C10.6667 10.2985 10.9652 10 11.3334 10H15.3334C15.7015 10 16 10.2985 16 10.6667C16 11.0349 15.7015 11.3333 15.3334 11.3333H11.3334C10.9652 11.3333 10.6667 11.0349 10.6667 10.6667Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_623_1689",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgSettings;
